var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTwitter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16.1 13.05",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "twitter")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.66.24a6.62,6.62,0,0,1-2.1.8A3.31,3.31,0,0,0,7.84,3.3,3.06,3.06,0,0,0,7.93,4,9.39,9.39,0,0,1,1.12.6a3.29,3.29,0,0,0,1,4.4A3.39,3.39,0,0,1,.65,4.59v0A3.3,3.3,0,0,0,3.3,7.86a3.27,3.27,0,0,1-1.49,0A3.29,3.29,0,0,0,4.89,10.2a6.64,6.64,0,0,1-4.1,1.41c-.27,0-.53,0-.79,0a9.45,9.45,0,0,0,5.06,1.48,9.32,9.32,0,0,0,9.4-9.38V3.25A6.54,6.54,0,0,0,16.1,1.54a6.53,6.53,0,0,1-1.9.52A3.33,3.33,0,0,0,15.66.24Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter.7e729a9f.svg";
export { ForwardRef as ReactComponent };